'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lingojsCore = require('@bookingcom/lingojs-core');

function weekdayNames(i18n, options) {
    if (!i18n) {
        throw new Error('No i18n object provided');
    }
    return [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ].reduce(function (result, weekDay, index) {
        result[weekDay] = i18n.trans(lingojsCore.t('weekday_formatted_date', (index + 1).toString(), options.form));
        return result;
    }, {});
}

exports.weekdayNames = weekdayNames;
//# sourceMappingURL=weekday-names.js.map
